export default {
    app_name: process.env.VUE_APP_NAME,
    api_url: process.env.VUE_APP_API_URL,
    api_key: process.env.VUE_APP_API_KEY,
    item_url: process.env.VUE_APP_ITEM_URL,
    author_github_link: process.env.VUE_APP_AUTHOR_GITHUB_LINK,
    project_github_link: process.env.VUE_APP_PROJECT_GITHUB_LINK,
    i18n_locale: process.env.VUE_APP_I18N_LOCALE,
    i18n_locale_fallback: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    i18n_locale_supported: process.env.VUE_APP_I18N_SUPPORTED_LOCALE
};